import { useMemo } from 'react';

const useIpad = () => {
  const isPad = useMemo(() => {
    const userAgent = navigator.userAgent || '';
    const maxTouchPoints = navigator.maxTouchPoints || 0;
    const userAgentDataPlatform = navigator.userAgentData?.platform || '';
    const platform = navigator.platform || '';

    return (
      /iPad/.test(userAgent) ||
      (userAgentDataPlatform === 'MacIntel' && maxTouchPoints > 1) ||
      (platform === 'MacIntel' && maxTouchPoints > 1)
    );
  }, []);

  return isPad;
};

export default useIpad;
